// src/index.js

import "./index.css";
import "./App.css";

import "./components/login/login.css";
import "./components/topBar/appBar/appbar.css";
import "./components/topBar/userMenu/user.css";
import "./components/util/tables.css";
// Pre-existing gap: this stylesheet was never imported anywhere in the app,
// so <NotificationContainer/> (see App.js) had no positioning CSS at all —
// it just rendered as a plain block div wherever it fell in the page's
// normal document flow (bottom-left, after all routed content), instead of
// its intended fixed top-right toast corner.
import "react-notifications/lib/notifications.css";

import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { PublicClientApplication, EventType } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./authConfig";

// The ResizeObserver-loop error overlay suppressor now lives in
// public/index.html (an inline <head> script) instead of here — it has to
// register before bundle.js (which includes CRA's dev-mode error overlay
// client) loads, and this file is itself part of that same bundle, so a
// listener added here always loses that race. See index.html for details.

const msalInstance = new PublicClientApplication(msalConfig);

async function startApp() {
  await msalInstance.initialize();

  // Process redirect response BEFORE React renders
  try {
    const redirectResult = await msalInstance.handleRedirectPromise();
    if (redirectResult?.account) {
      msalInstance.setActiveAccount(redirectResult.account);
    }
  } catch (e) {
    console.error("MSAL handleRedirectPromise error:", e);
  }

  // If no active account but cached accounts exist, pick one
  if (!msalInstance.getActiveAccount()) {
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length > 0) {
      msalInstance.setActiveAccount(accounts[0]);
    }
  }

  // Keep active account updated on subsequent logins/token acquisitions
  msalInstance.addEventCallback((event) => {
    const payloadAccount = event?.payload?.account;
    if (!payloadAccount) return;

    if (
      event.eventType === EventType.LOGIN_SUCCESS ||
      event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS
    ) {
      msalInstance.setActiveAccount(payloadAccount);
    }
  });

  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <MsalProvider instance={msalInstance}>
      <App />
    </MsalProvider>,
  );
}

startApp();
reportWebVitals();
